var _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPositionBottomLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 180,
    height: 82,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 180,
    height: 82,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 50,
    width: 32,
    height: 32,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 50,
    width: 32,
    height: 32,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionBottomLeft);
export default __webpack_public_path__ + "static/media/position_bottom_left.3b0d8f5cad5cce7679b6c77faa0ab018.svg";
export { ForwardRef as ReactComponent };